import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";

const EASE = [0.22, 1, 0.36, 1];

export default function Services() {
  return (
    <section
      id="services"
      className="relative bg-obsidian py-24 md:py-32 border-t border-white/10"
      data-testid="services-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: EASE }}
          >
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-spartanorange" />
              <span className="font-mono text-xs tracking-[0.25em] uppercase text-white/70">
                Services We Provide
              </span>
            </div>
            <h2 className="font-display uppercase tracking-tighter text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
              One partner.
              <br />
              <span className="text-spartangreen">Every solution.</span>
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="max-w-sm text-white/55 text-base leading-relaxed"
          >
            Six integrated disciplines that carry your product from the first
            fill to the shipped pallet — engineered, installed and supported.
          </motion.p>
        </div>

        {/* Grid-border bento */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.no}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, ease: EASE, delay: (i % 3) * 0.08 }}
              className="group relative bg-obsidian p-8 md:p-10 min-h-[280px] flex flex-col justify-between hover:bg-surface transition-colors duration-300"
              data-testid={`service-card-${s.no}`}
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-sm text-spartanorange">{s.no}</span>
                <ArrowUpRight
                  size={22}
                  className="text-white/30 group-hover:text-spartanorange group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-300"
                />
              </div>
              <div>
                <h3 className="font-display uppercase tracking-tight text-white text-3xl md:text-[2rem] leading-tight group-hover:text-spartanorange transition-colors duration-300">
                  {s.title}
                </h3>
                <p className="mt-4 text-white/55 text-sm leading-relaxed">
                  {s.desc}
                </p>
              </div>
              <span className="absolute bottom-0 left-0 h-[3px] w-0 bg-spartanorange group-hover:w-full transition-[width] duration-500 ease-out" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
